"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigIntValue = exports.BigUIntValue = exports.I64Value = exports.U64Value = exports.I32Value = exports.U32Value = exports.I16Value = exports.U16Value = exports.I8Value = exports.U8Value = exports.NumericalValue = exports.BigIntType = exports.BigUIntType = exports.I64Type = exports.U64Type = exports.I32Type = exports.U32Type = exports.I16Type = exports.U16Type = exports.I8Type = exports.U8Type = exports.NumericalType = void 0;
const errors = __importStar(require("../../errors"));
const types_1 = require("./types");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
class NumericalType extends types_1.PrimitiveType {
    constructor(name, sizeInBytes, withSign) {
        super(name);
        this.sizeInBytes = sizeInBytes;
        this.withSign = withSign;
    }
    getClassName() {
        return NumericalType.ClassName;
    }
    hasFixedSize() {
        return this.sizeInBytes ? true : false;
    }
    hasArbitrarySize() {
        return !this.hasFixedSize();
    }
}
exports.NumericalType = NumericalType;
NumericalType.ClassName = "NumericalType";
class U8Type extends NumericalType {
    constructor() {
        super("u8", 1, false);
    }
    getClassName() {
        return U8Type.ClassName;
    }
}
exports.U8Type = U8Type;
U8Type.ClassName = "U8Type";
class I8Type extends NumericalType {
    constructor() {
        super("i8", 1, true);
    }
    getClassName() {
        return I8Type.ClassName;
    }
}
exports.I8Type = I8Type;
I8Type.ClassName = "I8Type";
class U16Type extends NumericalType {
    constructor() {
        super("u16", 2, false);
    }
    getClassName() {
        return U16Type.ClassName;
    }
}
exports.U16Type = U16Type;
U16Type.ClassName = "U16Type";
class I16Type extends NumericalType {
    constructor() {
        super("i16", 2, true);
    }
    getClassName() {
        return I16Type.ClassName;
    }
}
exports.I16Type = I16Type;
I16Type.ClassName = "I16Type";
class U32Type extends NumericalType {
    constructor() {
        super("u32", 4, false);
    }
    getClassName() {
        return U32Type.ClassName;
    }
}
exports.U32Type = U32Type;
U32Type.ClassName = "U32Type";
class I32Type extends NumericalType {
    constructor() {
        super("i32", 4, true);
    }
    getClassName() {
        return I32Type.ClassName;
    }
}
exports.I32Type = I32Type;
I32Type.ClassName = "I32Type";
class U64Type extends NumericalType {
    constructor() {
        super("u64", 8, false);
    }
    getClassName() {
        return U64Type.ClassName;
    }
}
exports.U64Type = U64Type;
U64Type.ClassName = "U64Type";
class I64Type extends NumericalType {
    constructor() {
        super("i64", 8, true);
    }
    getClassName() {
        return I64Type.ClassName;
    }
}
exports.I64Type = I64Type;
I64Type.ClassName = "I64Type";
class BigUIntType extends NumericalType {
    constructor() {
        super("BigUint", 0, false);
    }
    getClassName() {
        return BigUIntType.ClassName;
    }
}
exports.BigUIntType = BigUIntType;
BigUIntType.ClassName = "BigUIntType";
class BigIntType extends NumericalType {
    constructor() {
        super("Bigint", 0, true);
    }
    getClassName() {
        return BigIntType.ClassName;
    }
}
exports.BigIntType = BigIntType;
BigIntType.ClassName = "BigIntType";
/**
 * A numerical value fed to or fetched from a Smart Contract contract, as a strongly-typed, immutable abstraction.
 */
class NumericalValue extends types_1.PrimitiveValue {
    constructor(type, value) {
        super(type);
        this.value = new bignumber_js_1.default(value);
        this.sizeInBytes = type.sizeInBytes;
        this.withSign = type.withSign;
        if (this.value.isNaN()) {
            throw new errors.ErrInvalidArgument(`not a number: ${value}`);
        }
        if (!this.withSign && this.value.isNegative()) {
            throw new errors.ErrInvalidArgument(`negative, but type is unsigned: ${value}`);
        }
    }
    getClassName() {
        return NumericalValue.ClassName;
    }
    /**
     * Returns whether two objects have the same value.
     *
     * @param other another NumericalValue
     */
    equals(other) {
        return this.value.isEqualTo(other.value);
    }
    valueOf() {
        return this.value;
    }
    toString() {
        return this.value.toString();
    }
}
exports.NumericalValue = NumericalValue;
NumericalValue.ClassName = "NumericalValue";
class U8Value extends NumericalValue {
    constructor(value) {
        super(new U8Type(), new bignumber_js_1.default(value));
    }
    getClassName() {
        return U8Value.ClassName;
    }
}
exports.U8Value = U8Value;
U8Value.ClassName = "U8Value";
class I8Value extends NumericalValue {
    constructor(value) {
        super(new I8Type(), new bignumber_js_1.default(value));
    }
    getClassName() {
        return I8Value.ClassName;
    }
}
exports.I8Value = I8Value;
I8Value.ClassName = "I8Value";
class U16Value extends NumericalValue {
    constructor(value) {
        super(new U16Type(), new bignumber_js_1.default(value));
    }
    getClassName() {
        return U16Value.ClassName;
    }
}
exports.U16Value = U16Value;
U16Value.ClassName = "U16Value";
class I16Value extends NumericalValue {
    constructor(value) {
        super(new I16Type(), new bignumber_js_1.default(value));
    }
    getClassName() {
        return I16Value.ClassName;
    }
}
exports.I16Value = I16Value;
I16Value.ClassName = "I16Value";
class U32Value extends NumericalValue {
    constructor(value) {
        super(new U32Type(), new bignumber_js_1.default(value));
    }
    getClassName() {
        return U32Value.ClassName;
    }
}
exports.U32Value = U32Value;
U32Value.ClassName = "U32Value";
class I32Value extends NumericalValue {
    constructor(value) {
        super(new I32Type(), new bignumber_js_1.default(value));
    }
    getClassName() {
        return I32Value.ClassName;
    }
}
exports.I32Value = I32Value;
I32Value.ClassName = "I32Value";
class U64Value extends NumericalValue {
    constructor(value) {
        super(new U64Type(), value);
    }
    getClassName() {
        return U64Value.ClassName;
    }
}
exports.U64Value = U64Value;
U64Value.ClassName = "U64Value";
class I64Value extends NumericalValue {
    constructor(value) {
        super(new I64Type(), value);
    }
    getClassName() {
        return I64Value.ClassName;
    }
}
exports.I64Value = I64Value;
I64Value.ClassName = "I64Value";
class BigUIntValue extends NumericalValue {
    constructor(value) {
        super(new BigUIntType(), value);
    }
    getClassName() {
        return BigUIntValue.ClassName;
    }
}
exports.BigUIntValue = BigUIntValue;
BigUIntValue.ClassName = "BigUIntValue";
class BigIntValue extends NumericalValue {
    constructor(value) {
        super(new BigIntType(), value);
    }
    getClassName() {
        return BigIntValue.ClassName;
    }
}
exports.BigIntValue = BigIntValue;
BigIntValue.ClassName = "BigIntValue";
//# sourceMappingURL=numerical.js.map